import { IApp } from "@core/models/app.interfaces";
import { ROWS_PER_PAGE } from "@shared/models/table-view.model";

export enum MODAL_TYPES {
    SERVICE_MESSAGE = 'service-message',
    TERMS_AND_CONDITIONS = 'terms-conditions',
    REQUIRED_INFORMATION = 'required-information'
}
